<script>
import AccountGroups from "@/components/widgets/account-groups";
import Swal from "sweetalert2";
import _ from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    subClasses: {
      type: Array,
      default: () => [],
    },
    classifications: {
      type: Array,
      default: () => [],
    },
    selectedClassification: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    AccountGroups,
  },
  data() {
    return {
      submitted: false,
      tableData: this.subClasses,
      classificationOptions: this.classifications,
      modalTitle: "",
      fcModal: false,
      totalRows: this.subClasses.length,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "cluster",
      sortDesc: false,
      fields: [
        {
          key: "item",
          sortable: true,
          label: "",
          thStyle: { width: "50px" },
        },
        {
          key: "shortName",
          sortable: true,
        },
        {
          key: "classification",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],
      form: {
        id: 0,
        classification: "",
        shortName: "",
        sortOrder: 0,
        accountClassId: this.selectedClassification.id,
      },
      alert: {
        type: "",
        message: "",
      },
      indexSelected: -1,
      tableBusy: false,
      accountGroups: [],
    };
  },
  watch: {
    subClasses() {
      this.tableData = this.subClasses;
      this.totalRows = this.subClasses.length;
    },
    classifications() {
      this.classificationOptions = this.classifications;
    },
    selectedClassification() {
      this.form.accountClassId = this.selectedClassification.id;
    },
  },
  validations: {
    form: {
      classification: { required },
    },
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  created() {
    // this.tableBusy = true;
    // this.fetchFundClassifications();
    // this.fetchAllAccountGroups();
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addFC() {
      this.modalTitle = "Create New Sub Classification";
      this.fcModal = true;
      // this.$bvModal.show("modal-standard");
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (this.form.id > 0) {
          const nData = JSON.parse(JSON.stringify(this.form));
          // nData.goodMin = Number(this.getExactAmt(nData.goodMin));
          // nData.goodMax = Number(this.getExactAmt(nData.goodMax));
          this.$store
            .dispatch("finance/UpdateFundClassification", nData)
            .then((res) => {
              this.tableData.splice(this.indexSelected, 1, res.data);
              this.fcModal = false;
              this.onReset();
              this.showToast("Successfully updated!", "success");
            })
            .catch(() => {
              this.showToast(
                "Something went wrong. Cannot update record",
                "error"
              );
            });
        } else {
          const nData = JSON.parse(JSON.stringify(this.form));
          // nData.goodMin = Number(this.getExactAmt(nData.goodMin));
          // nData.goodMax = Number(this.getExactAmt(nData.goodMax));
          this.$store
            .dispatch("finance/CreateFundClassification", nData)
            .then((res) => {
              this.tableData.push(res.data);
              this.fcModal = false;
              this.onReset();
              this.showToast("Successfully created!", "success");
            })
            .catch(() => {
              this.showToast(
                "Something went wrong. Cannot create record",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    onReset() {
      this.form = {
        id: 0,
        classification: "",
        shortName: "",
        sortOrder: 0,
        accountClassId: null,
      };
    },
    updateItem(props) {
      this.form = {
        id: props.item.id,
        classification: props.item.classification,
        shortName: props.item.shortName,
        sortOrder: props.item.sortOrder,
        accountClassId: props.item.accountClassId,
      };
      this.indexSelected = this.tableData.indexOf(props.item);
      this.modalTitle = "Update Sub Classification";
      this.fcModal = true;
    },
    hideModal() {
      this.fcModal = false;
    },
    deleteItem(props) {
      var index = this.tableData.indexOf(props.item);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("finance/DeleteFundClassification", props.item.id)
            .then((res) => {
              if (res.status == 204) {
                this.tableData.splice(index, 1);
                this.showToast("Successfully deleted!", "success");
              }
            })
            .catch(() => {
              this.showToast(
                "Something went wrong. Sub Classification cannot be deleted.",
                "error"
              );
            });
        }
      });
    },
    viewAccountGroups(item) {
      this.$router.push({ name: "Account Group", params: { id: item.id } });
    },
    fetchAllAccountGroups() {
      this.$store
        .dispatch("accountgroups/getAllAccountGroup")
        .then((response) => {
          this.accountGroups = response.data;
        })
        .catch(() => {
          this.showToast(
            "Something went wrong. Cannot fetch account groups.",
            "error"
          );
        });
    },
    fetchFundClassifications() {
      this.$store
        .dispatch("finance/GetFundClassification")
        .then((res) => {
          this.tableBusy = false;
          this.tableData = res.data.map((item) => ({
            ...item,
            accountGroups: [],
            rotateChevy: false,
          }));
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong! Cannot fetch Sub Classification",
            "error"
          );
        });
    },
    fetchAccountGroups(row) {
      row.item.isLoading = true;
      this.$store
        .dispatch(
          "accountgroups/getAccountGroupByFundClassification",
          row.item.id
        )
        .then((response) => {
          if (row.item.accountGroups) {
            row.item.accountGroups = response.data.map((item) => ({
              ...item,
              accounts: [],
              showDtls: false,
            }));
            row.item.isLoading = false;
          } else {
            this.tableData.find(
              (item) => item.id === row.item.id
            ).accountGroups = response.data.map((item) => ({
              ...item,
              accounts: [],
              showDtls: false,
            }));
            row.item.isLoading = false;
          }
          // this.fetchAllAccountGroups();
        })
        .catch(() => {
          this.showToast(
            "Something went wrong. Cannot fetch account groups",
            "error"
          );
        });
    },
    fetchAccounts(row) {
      if (!row.class) {
        row.showDtls = !row.showDtls;
      }
      this.$store
        .dispatch("accounts/getAccountByAccountGroup", row.id)
        .then((response) => {
          const collator = new Intl.Collator("en", {
            numeric: true,
            sensitivity: "base",
          });
          let sortedAccounts = response.data.sort((a, b) =>
            collator.compare(a.uacs, b.uacs)
          );
          if (row.accounts) {
            row.accounts = sortedAccounts;
          } else {
            this.tableData
              .find((item) => item.id === row.class)
              .accountGroups.find(
                (item) => item.id === row.id
              ).accounts = sortedAccounts;

            this.tableData
              .find((item) => item.id === row.class)
              .accountGroups.find((item) => item.id === row.id).showDtls = true;
          }
        })
        .catch(() => {
          this.showToast(
            "Something went wrong. Cannot fetch accounts",
            "error"
          );
        });
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.toggleDetails();
      if (row.item.rotateChevy) {
        this.fetchAccountGroups(row);
      }
    },
    printAccounts() {
      this.$emit("printAccounts");
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <b-alert
        :show="alert.type === 'success'"
        dismissible
        @dismissed="alert.type = ''"
        variant="success"
      >
        <i class="mdi mdi-check-all me-2"></i>{{ alert.message }}
      </b-alert>
      <b-alert
        :show="alert.type === 'danger'"
        dismissible
        @dismissed="alert.type = ''"
        variant="danger"
      >
        <i class="mdi mdi-block-helper me-2"></i>{{ alert.message }}
      </b-alert>
      <b-alert
        :show="alert.type === 'warning'"
        dismissible
        @dismissed="alert.type = ''"
        variant="warning"
      >
        <i class="mdi mdi-alert-outline me-2"></i>{{ alert.message }}
      </b-alert>
      <div class="card mt-4">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="card-title m-0">Sub Classification List</h4>
            <aside class="d-flex align-items-center">
              <!-- <button
                type="button"
                @click="printAccounts"
                class="btn btn-sm btn-success me-3 w-md"
              >
                <i class="bx bx-printer fs-6 align-middle me-2"></i>Print
                Accounts
              </button> -->
              <button
                type="button"
                @click="addFC()"
                class="btn btn-sm btn-primary w-md"
              >
                <i class="bx bx-plus fs-6 align-middle me-2"></i>Create New
              </button>
            </aside>

            <b-modal
              v-model="fcModal"
              :title="modalTitle"
              size="md"
              title-class="font-18"
              hide-footer
            >
              <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="fcForm"
              >
                <div class="mb-3">
                  <label for="classification">Classification</label>
                  <input
                    id="classification"
                    type="text"
                    v-model="form.classification"
                    placeholder="Enter Classification..."
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.form.classification.$error,
                    }"
                  />
                  <div
                    v-if="submitted && $v.form.classification.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.form.classification.required"
                      >This value is required.</span
                    >
                  </div>
                </div>
                <div class="mb-3">
                  <label for="classification">Short Name</label>
                  <input
                    id="shortName"
                    type="text"
                    v-model="form.shortName"
                    placeholder="Enter Short name..."
                    class="form-control"
                  />
                </div>
                <b-form-group label="Order" class="mb-3">
                  <b-form-input
                    type="number"
                    v-model="form.sortOrder"
                    class="form-control"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Classification" class="mb-3">
                  <b-form-select
                    class="form-select"
                    :options="classificationOptions"
                    v-model="form.accountClassId"
                  ></b-form-select>
                </b-form-group>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">
                    Save changes
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="hideModal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </b-modal>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    class="form-select form-select-sm mx-1"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <div class="table-responsive mb-0">
            <b-table
              class="table table-bordered"
              :items="tableData"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :busy="tableBusy"
              @filtered="onFiltered"
              bordered
              outlined
              hover
              striped
              show-empty
            >
              <template #empty="scope">
                <div class="text-center">
                  <h5 class="text-secondary">{{ scope.emptyText }}</h5>
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="float-end">
                  <b-dropdown
                    id="dropdown-dropleft"
                    right
                    variant="link"
                    toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end"
                    no-caret
                  >
                    <template #button-content>
                      <i class="fas fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item
                      @click="viewAccountGroups(row.item)"
                      variant="secondary"
                    >
                      <i class="mdi mdi-view-list font-size-18 me-1"></i> View
                      Account Groups
                    </b-dropdown-item>
                    <b-dropdown-item @click="updateItem(row)" variant="info"
                      ><i class="bx bx-edit font-size-18 me-1"></i
                      >Update</b-dropdown-item
                    >
                    <b-dropdown-item @click="deleteItem(row)" variant="danger"
                      ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                      >Delete</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </template>
              <template #cell(item)="row">
                <div
                  class="d-flex align-items-center justify-content-center"
                  @click="showDtls(row)"
                >
                  <i
                    class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                    :class="{
                      'rotate-90': row.item.rotateChevy,
                    }"
                  ></i>
                </div>
              </template>
              <template #row-details="row">
                <div class="text-center align-middle" v-if="row.item.isLoading">
                  <h5 class="text-secondary mb-0">
                    <i class="bx bx-hourglass bx-spin me-2"></i> Fetching
                    account groups
                  </h5>
                </div>
                <div v-else>
                  <AccountGroups
                    v-if="row.item.accountGroups"
                    :accountGroups="row.item.accountGroups"
                    :classification="row.item.id"
                    :fundClassifications="tableData"
                    :allAccountGroups="accountGroups"
                    :selected="selectedClassification"
                    @fetchAccounts="fetchAccounts"
                    @fetchAccountGroups="fetchAccountGroups"
                  />
                </div>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </Layout> -->
</template>
